angular.module('common.directives').directive('edgeEvent', function () {
  return {
    scope: {
      edge: '='
    },
    templateUrl: './templates/edgeEvents.view.html?t=' + webpackHash,
    link: function ($scope, $element) {},
    controller: 'edgeEventsController'
  }
})
